import { createFileRoute } from "@tanstack/react-router";
import { DefinitionPage } from "@/components/site/DefinitionPage";
import { definitionHead } from "@/lib/seo/definition-head";
import { definitionBySlug } from "@/content/definitions";

const ENTRY = definitionBySlug("premiumfilm-pa-abonnemang")!;

export const Route = createFileRoute("/ordlista_/premiumfilm-pa-abonnemang")({
  head: () => definitionHead(ENTRY),
  component: () => <DefinitionPage entry={ENTRY} />,
});
